import { FeatureFlag } from '@ps/web-core-enums';
import { Translation } from '@ps/web-shared-components';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useFeature from '@swf/core/hooks/useFeature';
import type { Dispatch, RootState } from '@swf/core/store';

import { useHomeGamesWidget } from '../../../model';
import { HGOnboarding, ModalRoutes } from '../../../types/common';
import NoData from '../../NoData/NoData';
import ClubButtons from '../ClubButtons/ClubButtons';

import {
  TXTWCL_No_Clubs_to_Show,
  TXTWCL_Your_clubs_will_be_shown_here
} from './NoClubs.messages.json';
import styles from './NoClubs.scss';

const NoClubs: React.FC = () => {
  const { modal } = useDispatch<Dispatch>();
  const { widgetId, widgetSelect } = useHomeGamesWidget();
  const newUserOnBoardingCompleted = useSelector((rootState: RootState) =>
    widgetSelect.localStorageItem(rootState, `onboarding[${HGOnboarding.NewUserFlow}]`)
  );
  const newUserOBFlowEnabled = useFeature(FeatureFlag.PKRHomeGamesOnboardingFirstTime);

  useEffect(() => {
    if (newUserOnBoardingCompleted) return;
    if (!newUserOBFlowEnabled) return;

    modal.enqueue({
      path: ModalRoutes.onBoardingNewUser,
      locationState: { widgetId }
    });
  }, [modal, newUserOBFlowEnabled, newUserOnBoardingCompleted, widgetId]);

  return (
    <NoData
      className={styles.noData}
      primaryText={<Translation {...TXTWCL_No_Clubs_to_Show} />}
      secondaryText={<Translation {...TXTWCL_Your_clubs_will_be_shown_here} />}
    >
      <ClubButtons className={styles.noDataButtons} />
    </NoData>
  );
};

export default NoClubs;
